import * as React from "react";

import { SocialNetworkProfiles } from "@/components/SocialNetworkProfiles";

export function EmbeddedPlayerSocialAccounts() {
  return (
    <div className={"flex flex-row w-full px-4 pb-8 justify-center"}>
      <SocialNetworkProfiles />
    </div>
  );
}
